import qs from 'qs';
import { useLocation } from '@gatsbyjs/reach-router';
const useQueryData = (to = '') => {
    const { search, pathname } = useLocation();
    const queryParts = to.split(/(?=[(?#)])/);
    const path = queryParts.find(x => x[0] !== '?' && x[0] !== '#') || (to !== '' ? pathname : '');
    const query = queryParts.find(x => x[0] === '?');
    const hash = queryParts.find(x => x[0] === '#');
    const linkQueryString = qs.parse((query || '').replace('?', ''));
    //const pageQueryString = qs.parse((search || '').replace('?', ''));
    const builtQueryString = qs.stringify({ ...linkQueryString });
    // path, querystring, hash
    return [path, builtQueryString ? `?${builtQueryString}` : '', hash || ''];
};
export default useQueryData;
//# sourceMappingURL=use-query-data.js.map